import { SystemEdge } from './models';
/**
 * Cell namespace for system shapes like Placeholder, Button, ButtonEdge, Edge
 */
export const systemModelNamespace = {
    [SystemEdge.type]: SystemEdge,
};
